
window.ValetBookNow = {
    init() {
        const button = document.querySelector("[data-book-now]");
        if (!button) return;

        button.addEventListener("click", this.submit.bind(this));
    },

    async submit() {
        const booking = window.valetBooking;

        if (!booking) {
            console.error("[Valet] Booking data not found.");
            return;
        }

        const batchId =
            "valet-" +
            Date.now() +
            "-" +
            Math.random().toString(36).slice(2, 9);

        const formatDate = (date, locale) => {
            if (!date) return "";
            const parsed = new Date(date);
            if (Number.isNaN(parsed.getTime())) return "";
            return parsed.toLocaleDateString(locale, {
                day: "numeric",
                month: "long",
                year: "numeric"
            });
        };

        const properties = {
            batch_id: batchId,
            "Storage Duration": booking.duration,
            "Monthly Cost": booking.monthlyCost,
            "Number of Crates": booking.crates,
            "Delivery Date": formatDate(booking.deliveryDate, "en-SG"),
            "Collection Date": formatDate(booking.collectionDate, "en-GB"),
            "Full Name": booking.address?.fullName || "",
            "Phone Number": booking.address?.phone || "",
            "Delivery Address": [
                booking.address?.line1,
                booking.address?.line2,
                booking.address?.unit,
                booking.address?.postcode
            ].filter(Boolean).join("\n"),
            "Unit Number": booking.address?.unit || "",
            "Postal Code": booking.address?.postcode || "",
            "Elevator": booking.address?.elevator || ""
        };

        try {
            // Add elevator fee to the same booking batch.
            if (
                booking.elevatorCharge?.enabled &&
                booking.elevatorCharge?.variantId
            ) {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({
                        id: Number(booking.elevatorCharge.variantId),
                        quantity: 1,
                        properties: {
                            batch_id: batchId
                        }
                    })
                });

                if (!response.ok) {
                    throw new Error("Unable to add elevator fee.");
                }
            }

            if (!window.ExXtraAddToCart) {
                throw new Error("ExXtraAddToCart helper not found.");
            }

            await window.ExXtraAddToCart.add({
                variantId: booking.variantId,
                sellingPlan: booking.sellingPlan,
                quantity: booking.crates,
                properties,
                address: booking.address,
                insurance: booking.insurance,
                service: "valet-storage"
            });

        } catch (error) {
            console.error("[Valet] Booking submission failed:", error);
            alert("Unable to add your booking to cart. Please try again.");
        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    window.ValetBookNow.init();
});
